import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Textarea } from 'components/fields'
import { ImagePicker } from 'containers/misc'
import { Note } from 'components/misc'
import { ElevatedButton } from 'components/layout'
import { form } from 'helpers/decorators'
import validate from './send-aj-completion.validation'

@form({
  form: 'AJCompletions',
  disableHook: true,
  validate
})
class SendRPCompletion extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    reset: PropTypes.func,
    id: PropTypes.number,
    colorClass: PropTypes.string,
    submitDisabled: PropTypes.bool,
    submitting: PropTypes.bool,
    onCancel: PropTypes.func,
    isEditing: PropTypes.bool
  }

  handleSubmit = fields =>
    this.props.onSubmit(this.props.id, fields, { resetForm: this.props.reset })

  render() {
    const {
      handleSubmit,
      colorClass,
      loading,
      submitDisabled,
      onCancel,
      isEditing,
      submitting
    } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Note margin="20px 0 30px">
          <FormattedMessage
            id="label.after_your_journey_describe"
            defaultMessage="After your Journey describe your observations in a few sentences."
          />
        </Note>
        <Textarea
          name="observations"
          label="Journey Observations"
          intlKey="label.journey_observations"
        />
        <ImagePicker name="fileUrls" isFile />

        <ElevatedButton
          colorClass={colorClass}
          uppercase
          rounded
          submit
          padded
          isLoading={loading || submitting}
          intlKey="button.send_for_approval"
          disabled={submitDisabled}
          inline
        >
          Send for approval
        </ElevatedButton>
        {isEditing &&
          <span style={{ marginLeft: 10 }}>
            <ElevatedButton
              uppercase
              submit
              padded
              onClick={onCancel}
              flat
              inline
              intlKey="button.cancel"
            >
              Cancel
            </ElevatedButton>
          </span>}
      </form>
    )
  }
}

export default SendRPCompletion
